import { render, staticRenderFns } from "./TestProductionList.vue?vue&type=template&id=e4a83ef6&scoped=true"
import script from "./TestProductionList.vue?vue&type=script&lang=js"
export * from "./TestProductionList.vue?vue&type=script&lang=js"
import style0 from "./TestProductionList.vue?vue&type=style&index=0&id=e4a83ef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a83ef6",
  null
  
)

export default component.exports